<template>
<div class="vid-sub">
</div>
</template>

<script>
import moment from 'moment';
import formatters from './formatters';
import payment from './payment';
export default {
  mixins: [formatters, payment],
  props: ["group", "video"],
  data: ()=>({
  }),
  computed: {
  },
  methods: {
    mediaUrl(obj) {
      if (!obj)
        return null;
      var rootUrl="";
      if (obj.store && obj.store.rootUrl)
        rootUrl=obj.store.rootUrl;
      if (obj.thumbnail)
        return rootUrl+obj.path.replace(/\/[^/]*$/, "/")+obj.thumbnail;
      else
        return rootUrl+obj.path;
    },
    textToHtml(text) {
      text=(text || "")+"";
      text=text.replace(/\n/g, "<br />");
      return text;
    },
    selectPackage(variant) {
//       appRoot.selectedPackage=this.item;
//       appRoot.selectedVideo=this.video;
      appCart.pushItem("v", this.video.id, variant);
    },
  },
  mounted() {
    this.loadItem();
    this.loadUserData();
  },
}
</script>
